import { CrudOp, fakomAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { FAKOMIcon } from "@org-avp/avp-avengers-ui-shared-icons";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { MaterialInfoView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator, { project }) => {
  const authHelper = authHelperCreator(fakomAuthScope);
  return project != null && authHelper.evaluate(CrudOp.READ, project);
};

export const materialInfoViewKey = "project_modular_material/:projectId/:subprojectId/:modelYear";
export const materialInfoViewModule: ViewModule = {
  viewKey: materialInfoViewKey,
  viewEl: <MaterialInfoView/>,
  displayNameI18nKey: "material:viewName",
  menuIconEl: <FAKOMIcon/>,
  isAuthorized,
  translations,
};
